export const reloadDataIfNeeded = async (dispatch, load, id, lastLoaded) => {
  const now = new Date();

  // Check if we haven't loaded data yet...
  if (!lastLoaded) {
    return dispatch(load(id));
  }

  // ...or if the data is stale (e.g., older than 5 minutes)
  const lastLoadedDate = new Date(lastLoaded);
  const fiveMinutes = 5 * 60 * 1000;

  if (now - lastLoadedDate > fiveMinutes) {
    return dispatch(load(id));
  }
};
